import { SMS_RESEND_STATUSES } from '@portal/kit/pkg/services'

export const getSmsResendStatus = e => {
  let resendStatus = SMS_RESEND_STATUSES.ERROR

  if (e.response && e.response.data && e.response.data.errors) {
    const codes = Object.keys(e.response.data.errors).map(field =>
      e.response.data.errors[field].map(error => error.code)
    ).flat()

    if (codes.indexOf('limit_reached') > -1) {
      resendStatus = SMS_RESEND_STATUSES.LIMIT_REACHED
    }
  }

  return resendStatus
}
